import styled from '@emotion/styled'

import { BILLS_LIST_HEIGHT } from './elements/SubjectsList/constants/billsListHeight'

export const BillsListWrapper = styled.div`
  height: ${BILLS_LIST_HEIGHT}px;
`
